<template>
	<div
		class="switch"
		:class="wrapperClass"
	>
		<slot name="pre" />
		<div
			role="checkbox"
			class="switch__input"
			tabindex="0"
			@click="handleToggle"
			@keydown.space.prevent="handleToggle"
		>
			<div class="switch__input__indicator" />
		</div>
		<slot name="post" />
	</div>
</template>

<script>
export default {
	name:  'SwitchInput',
	props: {
		value: {
			type:     Boolean,
			required: true,
		},
		classes: {
			type:    String,
			default: '',
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		wrapperClass() {
			let valueClass = this.value ? 'on' : 'off';
			valueClass = valueClass + (this.disabled ? ' disabled' : '');
			return `${valueClass}`;
		},
	},
	methods: {
		handleToggle() {
			if (this.disabled) {
				return;
			}
			this.$emit('input', !this.value);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.switch {
	display: flex;
	align-items: center;

	&__input {
		position: relative;
		display: inline-block;
		width: 58px;
		height: 28px;
		border-radius: 100px;
		cursor: pointer;
		transition: background 0.2s ease-in-out;

		&__indicator {
			width: 28px;
			height: 28px;
			border-radius: 100px;
			transition: background 0.2s ease-in-out, transform 0.2s ease-in-out;
		}
	}

	&.disabled {
		opacity: 0.4;

		.switch__input {
			cursor: not-allowed;
		}
	}
}

//.switch.disabled {
//
//}

.switch.on .switch__input {
	background: var(--color-green-petrol);

	&__indicator {
		transform: translateX(30px);
		border: 2px solid var(--color-green-petrol);
		background: var(--color-soft-white);
	}
}

.switch.off .switch__input {
	background: var(--color-grey-200);

	&__indicator {
		border: 2px solid var(--color-grey-200);
		background: var(--color-soft-white);
	}
}
</style>
